import { ENV } from "@/env";
import type { Style } from "mapbox-gl";

const glyphs = `https://api.maptiler.com/fonts/{fontstack}/{range}.pbf?key=${ENV.maptilerKey}`;

/**
 * Style every map starts with. All layers are added to it at runtime.
 *
 * `transition` is zero on purpose: mapbox starts a 300 ms paint transition for every layer that gets paint
 * properties (on `addLayer` and on `setPaintProperty`). It ends the transition only while the layer is
 * rendered, so a layer with `visibility: "none"` keeps the transition forever, `Style.hasTransitions()` stays
 * true and the map repaints every frame. See docs/map-continuous-repaint.md.
 */
export const emptyStyle: Style = {
  version: 8,
  sources: {},
  layers: [],
  glyphs,
  transition: { duration: 0, delay: 0 },
};
